import React from "react";
import { Container } from "react-bootstrap";
import classnames from "classnames";

const HeaderBar = ({ heading, className }) => {
  return (
    <div className="header-bar">
      <Container className="h-100 d-flex align-items-center">
        <div className={classnames("header-text", className)}>{heading}</div>
      </Container>
    </div>
  );
};

export default HeaderBar;
